export default __webpack_public_path__ + "static/move-white-5ca95094d7268c3057fb56b85f3840bd.png";